module.exports = __webpack_public_path__ + "img/icon-stars-sprite.3753f145.svg";